import { get } from '../../utils/object-helpers';

export const getTracking = function(model) {
    const trackingList = get(model, 'action.trackingList', []);
    const data = trackingList.filter(item => item.actionKind === 'NAVSRC');
    return data.length ? JSON.stringify(data[0]) : '';
};
